import React, { useState } from "react";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import DirectiveSection from "./Sections/DirectiveSection.js";
import RegulationPdfSection from "./Sections/RegulationPdfSection.js";
import SearchSection from "./Sections/SearchSection.js";
import CtaSection from "./Sections/CtaSection.js";
import translations from "./translations.js";
import styles from "./claimCheckPageStyle.js";
import profile from "assets/img/ultragreen-logo-big.png";

const useStyles = makeStyles(styles);

export default function ClaimCheckPage(props) {
  const classes = useStyles();
  const { ...rest } = props;
  const [lang, setLang] = useState("hu");
  const t = translations[lang];

  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid,
  );

  const params = new URLSearchParams(window.location.search);
  const urlquery = params.get("urlquery");

  const toggleLang = () => {
    setLang((prev) => (prev === "hu" ? "en" : "hu"));
  };

  return (
    <div>
      <Header
        color="transparent"
        brand="UltraGreen"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 200,
          color: "white",
        }}
        {...rest}
      />
      <Parallax small filter image={require("assets/img/bg-granules.jpg")} />
      <div className={classNames(classes.main)}>
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={8}>
              <div className={classes.profile}>
                <div>
                  <img src={profile} alt="UltraGreen" className={imageClasses} />
                </div>
                <div className={classes.name}>
                  <div className={classes.typo}>
                    <h2 className={classes.title}>{t.heroTitle}</h2>
                  </div>
                  <div className={classes.typo}>
                    <p className={classes.description}>{t.heroSubtitle}</p>
                  </div>
                  <button className={classes.langToggle} onClick={toggleLang}>
                    {t.langToggle}
                  </button>
                </div>
              </div>
            </GridItem>
          </GridContainer>
        </div>
        <DirectiveSection t={t} />
        <RegulationPdfSection t={t} />
        <SearchSection t={t} urlquery={urlquery} />
        <CtaSection t={t} />
        <div className={classes.footerInfo}>
          <p className={classes.footerText}>{t.footerCompany}</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
